/**
 * Staggered scroll-in for inner elements inside .block-reveal (2027 blocks).
 */
(function () {
  var GRID_SELECTOR =
    '[class*="__grid"], [class*="__gallery"], [class*="__stats"], [class*="__transport-grid"], [class*="__bullets"]';
  var STAGGER = 0.09;
  var GRID_STAGGER = 0.06;

  function findRevealRoot(block) {
    return (
      block.querySelector('[class$="__inner"]') ||
      block.querySelector(".container") ||
      block
    );
  }

  function getTopLevelChunks(root) {
    var items = Array.from(root.children);

    if (items.length === 1 && items[0].children.length > 1) {
      var wrap = items[0];
      if (
        /__(panel|grid|inner)\b/.test(wrap.className) ||
        wrap.querySelector(GRID_SELECTOR)
      ) {
        items = Array.from(wrap.children);
      }
    }

    return items;
  }

  function pushItem(list, el, delay) {
    el.classList.add("block-reveal__item");
    el.style.setProperty("--reveal-delay", delay + "s");
    list.push(el);
  }

  function collectRevealItems(block) {
    var root = findRevealRoot(block);
    var chunks = getTopLevelChunks(root);
    var items = [];
    var delay = 0;

    chunks.forEach(function (chunk) {
      if (chunk.matches('[class*="__content"]') && chunk.children.length > 0) {
        Array.from(chunk.children).forEach(function (child) {
          pushItem(items, child, delay);
          delay += STAGGER;
        });
        return;
      }

      var grid =
        chunk.matches(GRID_SELECTOR) ? chunk : chunk.querySelector(GRID_SELECTOR);

      if (grid && grid.children.length >= 2) {
        Array.from(grid.children).forEach(function (cell) {
          pushItem(items, cell, delay);
          delay += GRID_STAGGER;
        });
        return;
      }

      pushItem(items, chunk, delay);
      delay += STAGGER;
    });

    return items;
  }

  function revealBlock(block) {
    if (block.classList.contains("is-visible")) return;
    block.classList.add("is-visible");
  }

  function init() {
    var blocks = document.querySelectorAll(".block-reveal");
    if (!blocks.length) return;

    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    blocks.forEach(function (block) {
      collectRevealItems(block);
    });

    if (reducedMotion) {
      blocks.forEach(function (block) {
        block.classList.add("is-visible");
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealBlock(entry.target);
          io.unobserve(entry.target);
        });
      },
      { root: null, rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );

    blocks.forEach(function (block) {
      var rect = block.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) {
        revealBlock(block);
      } else {
        io.observe(block);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
